import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Heading from '~/components/blocks/core/Heading';

const HeadingBlock = ({
    attrs: { anchor, textAlign, content, className, level, fontSize, textColor }
}) => (
    <Heading
        {...{
            anchor,
            textAlign,
            content,
            className,
            level,
            fontSize,
            textColor
        }}
    />
);

HeadingBlock.propTypes = {
    attrs: PropTypes.shape({
        anchor: PropTypes.string,
        textAlign: PropTypes.string,
        content: PropTypes.string.isRequired,
        level: PropTypes.number.isRequired,
        fontSize: PropTypes.string,
        textColor: PropTypes.string
    }).isRequired
};

export default HeadingBlock;

export const fragment = graphql`
    fragment HeadingBlockFragment on WpCoreHeadingBlock {
        name
        attrs: attributes {
            ... on WpCoreHeadingBlockAttributes {
                anchor
                textColor
                textAlign
                level
                fontSize
                content
                className
            }
        }
    }
`;

export const exampleData = [
    {
        variant: 'H2 Black Styles',
        description:
            'Text Color Options: Black, Red, Blue. Styles for Heading 1, 2, or 3 can be used on any Heading level.',
        props: {
            name: 'core/heading',
            attrs: {
                level: 2,
                content: 'Heading'
            }
        }
    },
    {
        variant: 'H3 Red Styles',
        props: {
            name: 'core/heading',
            attrs: {
                level: 3,
                content: 'Heading',
                textColor: 'red'
            }
        }
    },
    {
        variant: 'H4 Blue Styles',
        props: {
            name: 'core/heading',
            attrs: {
                level: 4,
                content: 'Heading',
                textColor: 'blue'
            }
        }
    }
];
